import { Typography } from "@material-ui/core";
export function preferredAgentText(renalImpairmentLevel, overWeightLimit) {
    let text = [];

    if (overWeightLimit) {        
        text.push([<Typography variant="h6" color="primary">
                        {(renalImpairmentLevel == 'severe') ? "Use IV Heparin" : "IV Heparin is preferred agent"}
                        <br/>
                        {(renalImpairmentLevel == 'severe') ? "as patient has severe renal impairment and is overweight or obese. CrCl estimates may also be inaccurate and evidence for use of enoxaparin is limited at extremes of body weight." : "because patient is overweight or obese. CrCl estimates may also be inaccurate and evidence for use of enoxaparin is limited at extremes of body weight."}
                    </Typography>]);
    } else {
        text.push([<Typography variant="h6" color="primary">
            {(renalImpairmentLevel == 'severe') ? "Use IV Heparin" : "Use Enoxaparin or IV Heparin"}
            <br/>
            {(renalImpairmentLevel == 'severe') ?? "as patient has severe renal impairment."}
        </Typography>]);
    }

    return text;
}